<script context="module">
  import BlockQuote from "$lib/contentTypes/BlockQuote.svelte";
  import Contributors from "$lib/contentTypes/Contributors.svelte";
  import FundraisingGraph from "$lib/contentTypes/FundraisingGraph.svelte";
  import ItemPreviewList from "$lib/contentTypes/ItemPreviewList.svelte";
  import TopicHeaderComponent from "$lib/contentTypes/TopicHeaderComponent.svelte";
  import LinkComponent from "$lib/contentTypes/LinkComponent.svelte";
  import HeroComponent from "$lib/contentTypes/HeroComponent.svelte";
  import Embed from "$lib/contentTypes/Embed/Embed.svelte";
  import ImageComponent from "$lib/contentTypes/ImageComponent.svelte";
  import ImageGroup from "$lib/contentTypes/ImageGroup.svelte";
  import Menu from "$lib/contentTypes/Menu.svelte";
  import CallToActionComponent from "$lib/contentTypes/CallToActionComponent.svelte";
  import ContentGroup from "$lib/contentTypes/ContentGroup.svelte";
  import NavTarget from "$lib/contentTypes/NavTarget.svelte";
  import LayoutComponent from "$lib/contentTypes/LayoutComponent.svelte";
  import SocialShares from "$lib/contentTypes/SocialShares.svelte";
  import EmailSignupForm from "$lib/contentTypes/EmailSignupForm.svelte";
  import FundraiseUpElement from "$lib/contentTypes/FundraiseUpElement.svelte";

  //The section map is just the component map without section in it
  export const SECTION_COMPONENT_MAP = {
    blockQuote: BlockQuote,
    callToActionComponent: CallToActionComponent,
    contentGroup: ContentGroup,
    contributors: Contributors,
    emailSignup: EmailSignupForm,
    embed: Embed,
    fundraisingGraph: FundraisingGraph,
    fundraiseUpElement: FundraiseUpElement,
    heroComponent: HeroComponent,
    imageComponent: ImageComponent,
    imageGroup: ImageGroup,
    itemPreviewList: ItemPreviewList,
    layout: LayoutComponent,
    linkComponent: LinkComponent,
    menu: Menu,
    navTarget: NavTarget,
    topicHeaderComponent: TopicHeaderComponent,
    socialShares: SocialShares
  };
</script>

<script>
  import Section from "$lib/components/Section.svelte";
  import { setContext } from "svelte";

  export let data;

  const GREEN_VARIANT = {
    background: "bg-teal-50",
    eyebrow: "text-neutral-600",
    headline: "text-black"
  };
  const INDIGO_VARIANT = {
    background: "bg-indigo-50",
    eyebrow: "text-neutral-600",
    headline: "text-black"
  };

  const IVORY_VARIANT = {
    background: "bg-neutral-50",
    eyebrow: "text-neutral-600",
    headline: "text-black"
  };

  const GRAY_VARIANT = {
    background: "bg-neutral-100",
    eyebrow: "text-neutral-600",
    headline: "text-black"
  };

  const variantBackgrounds = {
    indigo: INDIGO_VARIANT,
    ivory: IVORY_VARIANT,
    gray: GRAY_VARIANT,
    green: GREEN_VARIANT
  };

  /** @type {"indigo" | "ivory" | "gray" | "green"} */
  const colorVariant = (data.fields.variant && data.fields.variant.toLowerCase()) || "";

  let colorBackground = variantBackgrounds[colorVariant]
    ? variantBackgrounds[colorVariant].background
    : "";
  let headlineColor = variantBackgrounds[colorVariant] && variantBackgrounds[colorVariant].headline;
  let headlineClass = variantBackgrounds[colorVariant]
    ? `${headlineColor} active:${headlineColor}`
    : `text-black active:text-black`;
  let eyebrowColor = variantBackgrounds[colorVariant] && variantBackgrounds[colorVariant].eyebrow;
  let eyebrowClass = variantBackgrounds[colorVariant]
    ? `${eyebrowColor} active:${eyebrowColor}`
    : "";

  let centeredClass = data.fields.centered ? "text-center md:text-left" : null;

  /**
   * I'm setting this context so that descendant components (especially LayoutComponents) can check the context to see
   * if they are descendants of a SectionComponent. Note that this context is only available to this component's descendants.
   */
  setContext("sectionDescendant", true);
</script>

<Section
  eyebrow={data.fields.eyebrow}
  headline={data.fields.headline}
  backgroundImage={!colorBackground ? data.fields.backgroundImage : null}
  body={data.fields.body}
  containerClass={colorBackground}
  contentClass={centeredClass || ""}
  {headlineClass}
  {eyebrowClass}
  componentMap={SECTION_COMPONENT_MAP}
/>
